import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    beneficiaryUsername: '',
	amount: 0, 
    message: '',
    channel: 'Web',
    transID: '',
    isTransactionSuccessfullyStarted: false,
    isTransactionSuccessfullyCompleted: false,
    isConfirmationDialogOpen: false,
    responseMessage: '',
    isLoading: false
};

export const p2pSlice = createSlice({
    name: 'p2p',
    initialState,
    reducers:{
        changeConfirmationDialogState : (state) => 
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        clearP2PSliceState: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            })
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'StartIPE2IPE')   
                {
                    state.transID = action.payload.response.transID
                    state.isConfirmationDialogOpen = true
                }
                else if(action.payload.endpoint === 'ConfirmIPE2IPE')
                {
                    state.isTransactionSuccessfullyCompleted = true
                    state.responseMessage = action.payload.response.errorMsg
                    state.success = action.payload.response.success
                }  
            })
    },
})

export const { clearP2PSliceState, changeConfirmationDialogState } = p2pSlice.actions;

export const selectP2PState = (state) => state.p2p;

export default p2pSlice.reducer;

